// extracted by mini-css-extract-plugin
export var root = "button-modules--root--33Q3a";
export var rootHover = "button-modules--rootHover--2_q_P";
export var containsIcon = "button-modules--containsIcon--1ujHF";
export var loaderContainer = "button-modules--loaderContainer--3PJy9";